module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleC1.4471f16e.png";